import bezier from '../libs/bezier-easing';

window._easings = {
	ease: bezier(0.42, 0, 0.58, 1),
	ease2: bezier(0.720, 0.000, 0.250, 1.000),
	easeOut: bezier(0.23, 1, 0.32, 1),
	easeIn: bezier(0.46, 0.04, 0.66, 0.32),
	default: bezier(0.25, 0.1, 0.25, 1),
};
window._cssEasings = {
	ease: 'cubic-bezier(0.42, 0, 0.58, 1)',
	ease2: 'cubic-bezier(0.720, 0.000, 0.250, 1.000)',
	easeOut: 'cubic-bezier(0.23, 1, 0.32, 1)',
	easeIn: 'cubic-bezier(0.46, 0.04, 0.66, 0.32)',
	default: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
};

(function(ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {return null}
		else return this.parentElement.closest(selector)
	};
}(Element.prototype));